// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsTanstackStartRouteImport } from './routes/docs/tanstack-start'
import { Route as DocsQuickstartRouteImport } from './routes/docs/quickstart'
import { Route as DocsNextjsRouteImport } from './routes/docs/nextjs'
import { Route as DocsHowItWorksRouteImport } from './routes/docs/how-it-works'
import { Route as DocsApiReferenceRouteImport } from './routes/docs/api-reference'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRoute
          })
const DocsTanstackStartRoute = DocsTanstackStartRouteImport.update({
            id: '/tanstack-start',path: '/tanstack-start',getParentRoute: () => DocsRoute
          })
const DocsQuickstartRoute = DocsQuickstartRouteImport.update({
            id: '/quickstart',path: '/quickstart',getParentRoute: () => DocsRoute
          })
const DocsNextjsRoute = DocsNextjsRouteImport.update({
            id: '/nextjs',path: '/nextjs',getParentRoute: () => DocsRoute
          })
const DocsHowItWorksRoute = DocsHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => DocsRoute
          })
const DocsApiReferenceRoute = DocsApiReferenceRouteImport.update({
            id: '/api-reference',path: '/api-reference',getParentRoute: () => DocsRoute
          })





const DocsRouteChildren = {
  DocsApiReferenceRoute: DocsApiReferenceRoute,DocsHowItWorksRoute: DocsHowItWorksRoute,DocsNextjsRoute: DocsNextjsRoute,DocsQuickstartRoute: DocsQuickstartRoute,DocsTanstackStartRoute: DocsTanstackStartRoute,DocsIndexRoute: DocsIndexRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DocsRoute: DocsRouteWithChildren,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)